(function () {
  var secs = document.querySelectorAll('[data-rev-product]');
  if (!secs.length) return;
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var LABELS = {
    self: { DE: 'Von diesem Produkt', AT: 'Von diesem Produkt', SK: 'Z tohto produktu', CZ: 'Z tohoto produktu', HU: 'Erről a termékről', PL: 'O tym produkcie', ES: 'De este producto', EN: 'This product' },
    others: { DE: 'Von anderen Größen der Reihe', AT: 'Von anderen Größen der Reihe', SK: 'Z iných rozmerov rady', CZ: 'Z jiných rozměrů řady', HU: 'A termékcsalád más méreteiről', PL: 'O innych rozmiarach serii', ES: 'De otras medidas de la gama', EN: 'Other sizes in the range' }
  };
  function label(kind, country) { var m = LABELS[kind] || {}; return m[country] || m.EN || m.ES || ''; }

  function itemHtml(rv) {
    var pct = Math.round(rv.rating) / 5 * 100;
    return '<article class="rev-item">'
      + '<div class="rev-item__head">'
      + '<span class="rev-stars__set" style="--rev-fill:' + pct + '%"><span class="rev-stars__on">★★★★★</span></span>'
      + (rv.author ? '<span class="rev-item__author">' + esc(rv.author) + '</span>' : '')
      + (rv.date ? '<time class="rev-item__date">' + esc(rv.date) + '</time>' : '')
      + '</div>'
      + (rv.title ? '<div class="rev-item__title">' + esc(rv.title) + '</div>' : '')
      + (rv.body ? '<p class="rev-item__body">' + esc(rv.body) + '</p>' : '')
      + '</article>';
  }
  function listHtml(reviews) {
    if (!reviews || !reviews.length) return '';
    var h = '';
    for (var i = 0; i < reviews.length; i++) h += itemHtml(reviews[i]);
    return h;
  }

  secs.forEach(function (sec) {
    if (sec.dataset.revLoaded) return;
    sec.dataset.revLoaded = '1';
    var pid = sec.getAttribute('data-rev-product');
    var family = (sec.getAttribute('data-rev-family') || '').trim();
    var box = sec.querySelector('[data-rev-items]');
    if (!pid || !box) return;

    var country = (sec.getAttribute('data-rev-country') || '').toUpperCase();
    if (!country) { try { country = (window.Shopify && Shopify.country) ? String(Shopify.country).toUpperCase() : ''; } catch (e) {} }

    // Sin gama -> una sola lista (comportamiento clasico).
    if (!family) {
      var qs = '/apps/b2b/reviews?product_id=' + encodeURIComponent(pid);
      if (country) qs += '&country=' + encodeURIComponent(country);
      fetch(qs, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.reviews || !d.reviews.length) { sec.style.display = 'none'; return; }
          box.innerHTML = listHtml(d.reviews);
        })
        .catch(function () { sec.style.display = 'none'; });
      return;
    }

    // Con gama -> pestañas: este producto / otras medidas.
    var qs2 = '/apps/b2b/reviews?product_id=' + encodeURIComponent(pid) + '&family=' + encodeURIComponent(family);
    if (country) qs2 += '&country=' + encodeURIComponent(country);
    fetch(qs2, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var self = (d && d.self) || { reviews: [], count: 0 };
        var others = (d && d.others) || { reviews: [], count: 0 };
        var selfN = self.count || (self.reviews ? self.reviews.length : 0);
        var othersN = others.count || (others.reviews ? others.reviews.length : 0);
        if (selfN === 0 && othersN === 0) { sec.style.display = 'none'; return; }

        var total = selfN + othersN;
        var totalEl = sec.querySelector('[data-rev-total]');
        if (totalEl) totalEl.textContent = String(total);

        // Aviso junto al titulo (enlace a #reviews) con el total real de la gama.
        var hintEl = document.querySelector('[data-rev-family-hint]');
        if (hintEl && total > 0) {
          var hintLbl = hintEl.getAttribute('data-rev-hint-label') || '';
          hintEl.textContent = total + ' ' + hintLbl;
          hintEl.hidden = false;
        }

        var tabsEl = sec.querySelector('[data-rev-tabs]');
        var current = selfN > 0 ? 'self' : 'others';

        function render(kind) {
          current = kind;
          var data = kind === 'self' ? self : others;
          box.innerHTML = listHtml(data.reviews);
          if (tabsEl) {
            var btns = tabsEl.querySelectorAll('.rev-tab');
            for (var i = 0; i < btns.length; i++) {
              btns[i].classList.toggle('is-active', btns[i].getAttribute('data-rev-tab') === kind);
            }
          }
        }

        if (tabsEl && othersN > 0) {
          var html = '';
          if (selfN > 0) html += '<button type="button" class="rev-tab" data-rev-tab="self">' + esc(label('self', country)) + ' (' + selfN + ')</button>';
          html += '<button type="button" class="rev-tab" data-rev-tab="others">' + esc(label('others', country)) + ' (' + othersN + ')</button>';
          tabsEl.innerHTML = html;
          tabsEl.hidden = false;
          tabsEl.addEventListener('click', function (e) {
            var b = (e.target && e.target.closest) ? e.target.closest('.rev-tab') : null;
            if (!b) return;
            render(b.getAttribute('data-rev-tab'));
          });
        }

        render(current);
      })
      .catch(function () { sec.style.display = 'none'; });
  });
})();
